import { observable } from 'mobx';

/**
 * 用户级队伍事实快照（root 共享 Store）。
 *
 * 队伍事实（是否组队/队伍ID）来源于各页面数据流（Team/Backpack 的 team_config、
 * EndedPoster 的 get_poster.invite_params），但小程序转发分享需要"当前账号人视角"
 * 的全页面统一事实。本 Store 只承载这份用户级事实快照：页面数据就绪时登记，
 * 全局分享 reaction 消费；不含任何页面编排状态（对齐 store-autonomy 边界）。
 *
 * null 表示尚未获得任何队伍事实（如仅停留 MAIN/GUEST/RULES 页）——分享语义按
 * "无队伍"处理（主入口），与产品确认的全页面分享口径一致。
 */
class TeamFactStore {
  /** @type {boolean|null} 当前账号是否拥有队伍；null=尚未获得事实 */
  @observable hasTeam = null;

  /** @type {string} 当前账号队伍 ID；无队伍或未获得事实时为空串 */
  @observable teamId = '';

  /**
   * 以页面刚提交的 Team 事实覆盖快照（loadTeam/initialize/loadPoster 成功后调用）。
   *
   * @param {object} fact 页面提交的队伍事实。
   * @param {boolean} fact.hasTeam 是否拥有队伍。
   * @param {string} fact.teamId 队伍 ID（无队伍时为空串）。
   * @returns {void}
   */
  update({ hasTeam, teamId } = {}) {
    this.hasTeam = Boolean(hasTeam);
    this.teamId = typeof teamId === 'string' ? teamId : '';
  }

  /**
   * 账号失效时清空队伍事实（快照跟随账号，不跨账号残留）。
   *
   * @returns {void}
   */
  invalidate() {
    this.hasTeam = null;
    this.teamId = '';
  }
}

export default TeamFactStore;
